import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import { WIZARD_STEP } from 'constants/wizardConstants';

export const NavigationBar = ({ step }) => {
  const checkStepStatus = current => {
    if (current === step) {
      return 'active';
    }
    if (current < step) {
      return 'done';
    }
    return '';
  };
  const indicatorLineStatus = current => {
    if (current < step) return 'active';
    return '';
  };

  return (
    <>
      {step < WIZARD_STEP.STATUS && (
        <div className="section--join">
          <div className="step-to-join">
            <div className="step-indicator">
              <div className={`step step1  ${checkStepStatus(1)}`}>
                <div className="step-icon">1</div>
                <p>{i18n.t('MB_T_ADD_JOBRANK_NAVI')}</p>
              </div>
              <div className={`indicator-line  ${indicatorLineStatus(1)}`} />
              <div className={`step step2  ${checkStepStatus(2)}`}>
                <div className="step-icon">2</div>
                <p>{i18n.t('BTY_W_T_DEPT_ADD_NAVI')}</p>
              </div>
              <div className={`indicator-line  ${indicatorLineStatus(2)}`} />
              <div className={`step step3  ${checkStepStatus(3)}`}>
                <div className="step-icon">3</div>
                <p>{i18n.t('PT_COMMON_MAIN_PAGE_SETTING_NAVI')}</p>
              </div>
              <div className={`indicator-line  ${indicatorLineStatus(3)}`} />
              <div className={`step step4  ${checkStepStatus(4)}`}>
                <div className="step-icon">4</div>
                <p>{i18n.t('BTY_W_T_ADD_MENU_NAVI')}</p>
              </div>
              <div className={`indicator-line  ${indicatorLineStatus(4)}`} />
              <div className={`step step5  ${checkStepStatus(5)}`}>
                <div className="step-icon">5</div>
                <p>{i18n.t('BTY_W_T_ADD_BORD_NAVI')}</p>
              </div>
              <div className={`indicator-line  ${indicatorLineStatus(5)}`} />
              <div className={`step step6  ${checkStepStatus(6)}`}>
                <div className="step-icon">6</div>
                <p>{i18n.t('BTY_W_T_ADD_ANNIVERSARY_NAVI')}</p>
              </div>
            </div>
          </div>
        </div>
      )}
      {step === WIZARD_STEP.STATUS && (
        <div className="header-container">
          <h1 className="large-title">{i18n.t('BTY_W_T_ALMOST_DONE')}</h1>
        </div>
      )}
      {step === WIZARD_STEP.GUIDE_1 && (
        <div className="header-container">
          <h1 className="large-title">{i18n.t('BTY_W_T_ADD_MORE_INFO')}</h1>
        </div>
      )}
      {step === WIZARD_STEP.GUIDE_2 && (
        <div className="header-container">
          <h1 className="large-title">{i18n.t('BTY_W_T_ADD_MORE_INFO')}</h1>
        </div>
      )}
      {step === WIZARD_STEP.GUIDE_3 && (
        <div className="header-container">
          <h1 className="large-title">{i18n.t('BTY_W_T_ADD_MORE_INFO')}</h1>
        </div>
      )}
    </>
  );
};

NavigationBar.propTypes = {
  step: PropTypes.number.isRequired,
};
NavigationBar.defaultProps = {};
export default NavigationBar;
